export default __webpack_public_path__ + "static/SupremeLL-LightItalic-d374c0203da45ff97715238daf4bddbb.woff";